export default __webpack_public_path__ + "static/media/m.30521d58.jpg";